import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { BaseModel } from '../../../models'
import { AppContext } from '../../../helpers'

@Injectable()
export class JsonApiBackendMock {

  public delete(model: BaseModel): Observable<any> {
    return Observable.of(JSON.stringify(model))
  }

  public findBy(type: string, searchCriteria: any): Observable<any[]> {
    return Observable.of(Object.assign({ id: (searchCriteria.id || '123') }, searchCriteria))
  }

  public save(models: BaseModel[]): Observable<any> {
    models.forEach((model, index) => {
      model.id = (index + 1).toString()
    })
    return Observable.of(JSON.parse(JSON.stringify(models)))
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/json-api-backend/json-api.backend.mock.ts